import type { StyleSpecification } from "maplibre-gl";

export type TileSourceId = "osm" | "google-road" | "google-satellite" | "cartodb-light" | "cartodb-dark";

export interface TileSourceDef {
	id: TileSourceId;
	label: string;
	style: StyleSpecification | string; // inline raster style or URL to vector style
}

function rasterStyle(tiles: string[], attribution = ""): StyleSpecification {
	return {
		version: 8,
		sources: {
			"raster-tiles": {
				type: "raster",
				tiles,
				tileSize: 256,
				attribution,
			},
		},
		layers: [{ id: "raster-layer", type: "raster", source: "raster-tiles" }],
	};
}

export const TILE_SOURCES: TileSourceDef[] = [
	{
		id: "google-satellite",
		label: "Google Satellite",
		style: rasterStyle(["https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"]),
	},
	{
		id: "google-road",
		label: "Google Road",
		style: rasterStyle(["https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"]),
	},
	{
		id: "osm",
		label: "OpenStreetMap",
		style: rasterStyle(
			["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
			'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
		),
	},
	// {
	// 	id: "cartodb-light",
	// 	label: "CartoDB Light",
	// 	style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
	// },
	// {
	// 	id: "cartodb-dark",
	// 	label: "CartoDB Dark",
	// 	style: "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json",
	// },
];

export const DEFAULT_TILE_SOURCE = TILE_SOURCES[0];
